export function shouldShowLevelUp(previous, level, enabled) {
  return enabled !== false && Number.isInteger(previous) && previous >= 1
    && Number.isInteger(level) && level > previous;
}
